export const stickerPanelEn = {
  dragUserHint: 'Drag user at some task to asign the user to this task',
  deadlineHint: 'Set a deadline',
  userHint: 'Set an assigned user',
  menuTitle: 'Add sticker',
  addHint: 'Add sticker to this task',
  deadlineFilterHint: 'Choose dates to filter board by deadline',
  boardFilter: 'Filter',
  setupDeadline: 'Setup deadline',
  chooseDeadline: 'Choose deadline date',
  chooseDeadlineRange: 'Choose dates',
  addNotification: 'Add notification',
  addStart: 'Add start date',
  addTaskStart: 'Add task start date',
  removeTaskStart: 'Remove task start date'
}

export const stickerPanelRu: typeof stickerPanelEn = {
  dragUserHint:
    'Перенесите мышью пользователя на задачу, чтобы назначить его исполнителем',
  deadlineHint: 'Назначить дедлайн задачи',
  userHint: 'Назначить исполнителя задачи',
  menuTitle: 'Добавить стикер',
  addHint: 'Прикрепить стикер к этой задаче',
  deadlineFilterHint: 'Выберите диапазон дат для фильтрации доски',
  boardFilter: 'Фильтрация',
  setupDeadline: 'Установка дедлайна',
  chooseDeadline: 'Выберите дату дедлайна',
  chooseDeadlineRange: 'Выберите даты',
  addNotification: 'Добавить напоминание',
  addStart: 'Добавить дату начала',
  addTaskStart: 'Добавить дату начала задачи',
  removeTaskStart: 'Убрать дату начала задачи'
}
